import { ConfigConsumer, ConfigContext, default as ConfigProvider, globalConfig } from "./ConfigProvider";
export default ConfigProvider;
export { ConfigContext, ConfigConsumer, globalConfig };